import { Formik } from 'formik';
import { useCallback } from 'react';
import { object } from 'yup';

import { Datum, RUNES_CALLOUT_TYPES } from '@frontend/api';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Flex,
} from '@frontend/components';

import { SubFormProps } from '../types';
import { SubFormWrapper } from './shared/SubFormWrapper';
import { createDatumLetterValidation } from './shared/validation';

type DatumFormValues = {
  letter: string;
};

const initialValues: DatumFormValues = {
  letter: '',
};

const validationSchema = object().shape({
  letter: createDatumLetterValidation(),
});

export const DatumForm = ({
  onSubmit,
  onCancel,
  renderSelectedType,
}: SubFormProps) => {
  const handleSubmit = useCallback(
    (values: DatumFormValues) => {
      // Build the final Datum object
      const datum: Datum = {
        calloutType: RUNES_CALLOUT_TYPES.DATUM,
      };

      onSubmit(datum, values.letter);
    },
    [onSubmit],
  );

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, errors, touched, isValid, isSubmitting }) => (
        <SubFormWrapper
          isValid={isValid}
          isSubmitting={isSubmitting}
          onCancel={onCancel}
          renderSelectedType={renderSelectedType}
          submitLabel="Add Datum"
        >
          {/* Datum Letter Input */}
          <Flex direction="column" gap={1} px={1} pb={1}>
            <FormControl>
              <FormLabel>Datum Letter</FormLabel>
              <Input
                name="letter"
                value={values.letter}
                onChange={(e) =>
                  setFieldValue('letter', e.target.value.toUpperCase())
                }
                placeholder="-"
                maxLength={1}
                size="sm"
                width="60px"
                textAlign="center"
                fontSize="lg"
              />
              {errors.letter && touched.letter && (
                <FormErrorMessage>{errors.letter}</FormErrorMessage>
              )}
            </FormControl>
          </Flex>
        </SubFormWrapper>
      )}
    </Formik>
  );
};
